import React, { useEffect, useState} from "react";
import { Form } from "react-bootstrap";
import { TextField, Tooltip, IconButton, FormControl, FormControlLabel, FormHelperText, FormLabel, InputLabel, MenuItem, Select } from "@mui/material"
import { HelpCenter } from "@mui/icons-material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Autocomplete from '@mui/material/Autocomplete';
import InputAdornment from '@mui/material/InputAdornment';

const SupplierForm = props => {
    const intRegex = /^-?\d*$/;

    return(
        <Form>
            <h5 style={{marginBottom:'2vh'}}>{props.createForm.supplier.value} form</h5>

            <FormControl disabled={props.modalState === 'edit' ? true : false }>
                <FormLabel id="device-supplier-label">Device Supplier</FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="device-supplier-label"
                    name="device-supplier-group"
                    value={props.createForm.supplier.value}
                    onChange={e => props.updateCreateFormValue('supplier', e.target.value)}
                >
                    {
                        props.suppliers.map((supplier, i) => (
                            <FormControlLabel disabled={supplier === 'Centrica'} value={supplier} key={i} control={<Radio />} label={supplier} />
                        ))
                    }
                </RadioGroup>
            </FormControl>

            {
                props.createForm.supplier.value === 'AlertLabs' && 
                <>
                <div style={{display:'flex', flexDirection:'row'}}>
                    <TextField
                        label="Device name"
                        variant="outlined"
                        name="device-name"
                        value={props.deviceName}
                        onChange={e => props.setDeviceName(e.target.value)}
                        style={{width:'100%', marginBottom:'1.5vh', flex:'84'}}
                        error={props.deviceNameError !== ''}
                        helperText={props.deviceNameError}
                    />

                    <div style={{flex:'2'}}></div>

                    <Tooltip title={`Name is appears in ${props.createForm.supplier.value} (case sensitive, copy+paste recommended`} style={{flex:'14'}} slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 0.5 }} style={{backgroundColor:'white'}}>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </div>

                <div style={{display:'flex', flexDirection:'row'}}>
                    <TextField
                        label="Device location name"
                        variant="outlined"
                        name="device-location-name"
                        value={props.deviceLocationName}
                        onChange={e => props.setDeviceLocationName(e.target.value)}
                        style={{width:'100%', marginBottom:'1.5vh', flex:'84'}}
                        error={props.deviceLocationNameError !== ''}
                        helperText={props.deviceLocationNameError}
                    />

                    <div style={{flex:'2'}}></div>

                    <Tooltip title={`Location name is appears in ${props.createForm.supplier.value} (case sensitive, copy+paste recommended)`} style={{flex:'14'}} slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 0.5 }} style={{backgroundColor:'white'}}>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </div>

                <FormControl style={{marginBottom:'1.25vh'}}>
                    <FormLabel id="demo-row-radio-buttons-group-label">AlertLabs Account</FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={props.alertLabsAccount}
                        onChange={e => props.setAlertLabsAccount(e.target.value)}
                    >
                        <FormControlLabel value="Enviro-Stewards" control={<Radio />} label="Enviro-Stewards" />
                        <FormControlLabel value="Gay Lea" control={<Radio />} label="Gay Lea" />
                    </RadioGroup>
                </FormControl>
                </>
            }

            {
                props.createForm.supplier.value === 'Edgecom' && 
                <>
                <div style={{display:'flex', flexDirection:'row'}}>
                    <TextField
                        label="Device name"
                        variant="outlined"
                        name="device-name"
                        value={props.deviceName}
                        onChange={e => props.setDeviceName(e.target.value)}
                        style={{width:'100%', marginBottom:'1.5vh', flex:'84'}}
                        error={props.deviceNameError !== ''}
                        helperText={props.deviceNameError}
                    />

                    <div style={{flex:'2'}}></div>

                    <Tooltip title={`Name is appears in ${props.createForm.supplier.value} (case sensitive, copy+paste recommended)`} style={{flex:'14'}} slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 0.5 }} style={{backgroundColor:'white'}}>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </div>

                <div style={{display:'flex', flexDirection:'row'}}>
                    <TextField
                        label="Device location name"
                        variant="outlined"
                        name="device-location-name"
                        value={props.deviceLocationName}
                        onChange={e => props.setDeviceLocationName(e.target.value)}
                        style={{width:'100%', marginBottom:'1.5vh', flex:'84'}}
                        error={props.deviceLocationNameError !== ''}
                        helperText={props.deviceLocationNameError}
                    />

                    <div style={{flex:'2'}}></div>

                    <Tooltip title={`Location name is appears in ${props.createForm.supplier.value} (case sensitive, copy+paste recommended)`} style={{flex:'14'}} slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 0.5 }} style={{backgroundColor:'white'}}>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </div>

                </>
            }

            {
                props.createForm.supplier.value === 'Milesight' && 
                <>
                <div style={{display:'flex', flexDirection:'row'}}>
                    <TextField
                        label="DevEUI"
                        variant="outlined"
                        name="deveui"
                        value={props.deveui}
                        onChange={e => props.setDeveui(e.target.value)}
                        style={{width:'100%', marginBottom:'1.5vh', flex:'84'}}
                        error={props.deveuiError !== ''}
                        helperText={props.deveuiError}
                    />

                    <div style={{flex:'2'}}></div>

                    <Tooltip title={`DevEUI is appears on ${props.createForm.supplier.value} hardware`} style={{flex:'14'}} slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 0.5 }} style={{backgroundColor:'white'}}>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </div>

                <div style={{display:'flex', flexDirection:'row'}}>
                    <TextField
                        label="Minimum battery level"
                        variant="outlined"
                        name="battery"
                        value={props.batteryThreshold}
                        onChange={e => {
                            if(!intRegex.test(e.target.value)) return;
                            props.setBatteryThreshold(e.target.value)
                        }}
                        style={{width:'100%', marginBottom:'1.5vh', flex:'84'}}
                        error={props.batteryThresholdError !== ''}
                        helperText={props.batteryThresholdError}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    %
                                </InputAdornment>
                            )
                        }}
                    />

                    <div style={{flex:'2'}}></div>

                    <Tooltip title={`Battery level (between 5-95%) to trigger a low battery alert`} style={{flex:'14'}} slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 0.5 }} style={{backgroundColor:'white'}}>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </div>

                <div style={{display:'flex', flexDirection:'row'}}>
                    <TextField
                        label="Minimum RSSI"
                        variant="outlined"
                        name="rssi"
                        value={props.rssiThreshold}
                        onChange={e => {
                            if(!intRegex.test(e.target.value)) return;
                            props.setRssiThreshold(e.target.value)
                        }}
                        style={{width:'100%', marginBottom:'1.5vh', flex:'84'}}
                        error={props.rssiThresholdError !== ''}
                        helperText={props.rssiThresholdError}
                    />

                    <div style={{flex:'2'}}></div>

                    <Tooltip title={`RSSI level (minimum -86) to trigger a poor signal alert`} style={{flex:'14'}} slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 0.5 }} style={{backgroundColor:'white'}}>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </div>

                <div style={{display:'flex', flexDirection:'row'}}>
                    <TextField
                        label="Minimum SNR"
                        variant="outlined"
                        name="snr"
                        value={props.snrThreshold}
                        onChange={e => {
                            if(!intRegex.test(e.target.value)) return;
                            props.setSnrThreshold(e.target.value)
                        }}
                        style={{width:'100%', marginBottom:'1.5vh', flex:'84'}}
                        error={props.snrThresholdError !== ''}
                        helperText={props.snrThresholdError}
                    />

                    <div style={{flex:'2'}}></div>

                    <Tooltip title="SNR level (between 0 and 30) to trigger a poor signal alert" style={{flex:'14'}} slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 0.5 }} style={{backgroundColor:'white'}}>
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </div>
                </>
            }

            {props.createForm.supplier.value === 'Offline' && <FormControl
                fullWidth
                error={props.deviceTypeError !== ''}
                style={{marginBottom:'1.5vh'}}
            >
                <InputLabel id="offline-device-type-label">Device type</InputLabel>
                <Select
                    labelId="offline-device-type-label"
                    id="offline-device-type"
                    label="Device type"
                    value={props.deviceType}
                    onChange={event => props.setDeviceType(event.target.value)}
                    MenuProps={{disablePortal:true}}
                >
                    <MenuItem value="Hoboware">Hoboware</MenuItem>
                    <MenuItem value="Ultrasonic">Ultrasonic</MenuItem>
                </Select>
                {props.deviceTypeError !== '' && <FormHelperText>{props.deviceTypeError}</FormHelperText>}
            </FormControl>}

            {props.createForm.supplier.value !== 'Offline' && <>
            <div style={{display:'flex', flexDirection:'row'}}>
                <TextField
                    label="Interval minutes"
                    variant="outlined"
                    name="sensor-name"
                    value={props.intervalMinutes}
                    onChange={e => {
                        if(!intRegex.test(e.target.value)) return;
                        props.setIntervalMinutes(e.target.value);
                    }}
                    style={{width:'100%', marginBottom:'1.5vh', flex:'84'}}
                    error={props.intervalMinutesError !== ''}
                    helperText={props.intervalMinutesError}
                />

                <div style={{flex:'2'}}></div>

                <Tooltip title="Resolution of data (e.g., for minute-by-minute, put 1)" style={{flex:'14'}} slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                    <IconButton sx={{ m: 0.5 }} style={{backgroundColor:'white'}}>
                        <HelpCenter/>
                    </IconButton>
                </Tooltip>
            </div>

            <div style={{display:'flex', flexDirection:'row'}}>
                <TextField
                    label="Gap minutes"
                    variant="outlined"
                    name="sensor-name"
                    value={props.gapMinutes}
                    onChange={e => {
                        if(!intRegex.test(e.target.value)) return;
                        props.setGapMinutes(e.target.value);
                    }}
                    style={{width:'100%', marginBottom:'1.5vh', flex:'84'}}
                    error={props.gapMinutesError !== ''}
                    helperText={props.gapMinutesError}
                />

                <div style={{flex:'2'}}></div>

                <Tooltip title="Anticipated reporting interval (if unsure, enter the lesser of 60 or interval minutes + 1)" style={{flex:'14'}} slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                    <IconButton sx={{ m: 0.5 }} style={{backgroundColor:'white'}}>
                        <HelpCenter/>
                    </IconButton>
                </Tooltip>
            </div>
            </>}
            {props.createForm.supplier.value === 'Milesight' && <Autocomplete
                multiple
                disablePortal
                disableCloseOnSelect
                loading={props.recipientLoading}
                disabled={props.recipientLoading}
                options={props.recipientOptions}
                value={props.recipientOptions.filter(user => props.recipientIds.includes(user.id))}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={user => `${user.first_name} ${user.last_name} (${user.email})`}
                onChange={(_, users) => {
                    props.setRecipientIds(users.map(user => user.id));
                    props.setRecipientError('');
                }}
                renderInput={params => <TextField {...params}
                    label="Notification recipients"
                    error={Boolean(props.recipientError)}
                    helperText={props.recipientError || 'Select at least one recipient for battery, RSSI and SNR alerts.'}
                    InputLabelProps={{...params.InputLabelProps, required: true}}
                />}
                sx={{marginBottom: '1.5vh'}}
            />}
        </Form>
    )
}

export default SupplierForm;
